import { useCallback } from 'react';

import { useNavigation as useExpoNavigation, useRouter } from 'expo-router';

import { INavigationHook } from 'navigation/types';
import { appendObjectToQueryString } from 'navigation/utils';
import noop from 'utils/noop';
import { routes } from 'utils/routing';

/** @deprecated use "useRouter" or "use[Local/Global]SearchParams" instead */
export const useNavigation = () => {
  const { replace, navigate: routerNavigate, back, canGoBack, setParams, dismissAll } = useRouter();
  const { setOptions } = useExpoNavigation();

  const navigate: INavigationHook['navigate'] = useCallback(
    (to, options) => {
      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.log('OLD navigate', { to, ...(options ? { options } : {}) });
      }
      if (options?.popCurrent) {
        dismissAll();
      }

      if (options?.state) {
        // expo router needs /foo/bar?baz=qux for passed state
        to = appendObjectToQueryString(to, options.state);
      }

      return (options?.replace ? replace : routerNavigate)(to);
    },
    [dismissAll, routerNavigate, replace]
  );

  const linkTo: INavigationHook['linkTo'] = navigate;

  const goBack = useCallback(
    ({ redirectToBaseIfNoState = false } = {}) => {
      if (!canGoBack() && redirectToBaseIfNoState) {
        return navigate(routes.base);
      }
      back();
    },
    [back, canGoBack, navigate]
  );

  return {
    navigate,
    linkTo,
    goBack,
    setParams,
    setOptions,
    setScreenHeaderTitle: noop,
  };
};
